/**
 * Wire-контракт общего каталога (`Platform.Contracts/Catalog/CatalogProductDtos.cs`) и его
 * проверка на границе: неожиданная форма — `invalid-response`, а не пустая таблица.
 */
import { integer, list, optionalText, record, text } from '../../../shared/decode'
import { decodeMainPhoto } from '../../common-photos/api/contracts'
import type { CommonCatalogIdentity, CommonCatalogPage, CommonProduct } from '../model/types'

function decodeIdentity(raw: unknown, name: string): CommonCatalogIdentity {
  const item = record(raw, name)
  return {
    resourceId: text(item.resourceId, `${name}.resourceId`),
    resourceKind: text(item.resourceKind, `${name}.resourceKind`),
    resourceName: text(item.resourceName, `${name}.resourceName`),
    remoteKey: text(item.remoteKey, `${name}.remoteKey`),
    origin: text(item.origin, `${name}.origin`),
    linkedAt: text(item.linkedAt, `${name}.linkedAt`),
  }
}

function decodeProduct(raw: unknown, name: string): CommonProduct {
  const item = record(raw, name)
  return {
    id: text(item.id, `${name}.id`),
    name: text(item.name, `${name}.name`),
    displayName: text(item.displayName, `${name}.displayName`),
    sku: optionalText(item.sku, `${name}.sku`),
    unitCode: optionalText(item.unitCode, `${name}.unitCode`),
    barcodeCount: integer(item.barcodeCount, `${name}.barcodeCount`),
    identities: list(item.identities, `${name}.identities`, decodeIdentity),
    hiddenIdentities: integer(item.hiddenIdentities, `${name}.hiddenIdentities`),
    mainPhoto: decodeMainPhoto(item.mainPhoto, `${name}.mainPhoto`),
  }
}

export function decodeCommonCatalogPage(raw: unknown): CommonCatalogPage {
  const page = record(raw, 'catalog')
  return {
    items: list(page.items, 'catalog.items', decodeProduct),
    page: integer(page.page, 'catalog.page'),
    pageSize: integer(page.pageSize, 'catalog.pageSize'),
    total: integer(page.total, 'catalog.total'),
  }
}
